import React, { forwardRef } from 'react';

import { Box } from '@mui/material';
import { isBoolean } from 'lodash';

import { CalendarSmallIcon } from '@setup/svg-icons/svg-icons';
import { MuiBaseTextFiled, MuiIconButton } from '@shared/ui-kit';
import { formatDateForView } from '@shared/utils/formatDateForView';

type GeneralDatepickerInputProps = {
  labelId?: string;
  inputId?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isFullWidth?: boolean;
  isError?: boolean;
  label?: string;
  placeholder?: string;
  value?: any;
  onChange?: () => void;
  isShowPopup?: boolean;
  errorMessage?: string;
  helperText?: string;
  isButton?: boolean;
  size?: 'small' | 'medium';
  isClearable?: boolean;
  dateFormat: string;
  [x: string]: any;
};

const GeneralDatepickerInput = forwardRef<HTMLHeadingElement, GeneralDatepickerInputProps>((props, ref) => {
  const {
    labelId,
    inputId,
    isDisabled,
    isError,
    isFullWidth = true,
    isRequired,
    isReadOnly,
    onChange,
    label,
    placeholder,
    helperText,
    errorMessage,
    value,
    size,
    isShowPopup,
    isButton,
    isClearable,
    dateFormat,
    ...args
  } = props;

  if (isButton) {
    return (
      <Box ref={ref}>
        <MuiIconButton disableBackground isStopPropagation={false} size="small" isDisabled={isDisabled}>
          <CalendarSmallIcon />
        </MuiIconButton>
      </Box>
    );
  }

  return (
    <MuiBaseTextFiled
      {...args}
      labelId={labelId}
      inputId={inputId}
      variant="outlined"
      label={label}
      ref={ref}
      value={formatDateForView(value, dateFormat || 'MMM DD YYYY')}
      isFullWidth={isFullWidth}
      defaultValue={undefined}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isRequired={isRequired}
      isError={isError}
      errorMessage={errorMessage}
      isReadOnly={isReadOnly}
      placeholder={placeholder}
      onChange={onChange}
      helperText={helperText}
      size={size}
      focused={isBoolean(isShowPopup) ? isShowPopup : undefined}
      inputProps={{
        readOnly: true,
        startAdornment: <CalendarSmallIcon />,
      }}
    />
  );
});

export default GeneralDatepickerInput;
